import { createReducer } from 'typesafe-actions';
import template from '@westwing/ui-kit/template';
import { get } from '../../../../common/utils/objectUtils';
import { HeaderBarBannerActionTypes, headerBarBannerActions } from './actions';
import { Banner, HeaderBarBannerState } from './types';

export const defaultState: HeaderBarBannerState = {
    didInvalidate: false,
    identifier: '',
    isFetching: false,
};

const formatData = (data: Banner): Banner | undefined => {
    return data
        ? {
              ...data,
              desktopHTML: template(data.desktopText || ''),
              mobileHTML: template(data.mobileText || ''),
          }
        : data;
};

const headerBarBannerReducer = createReducer<HeaderBarBannerState, HeaderBarBannerActionTypes>(defaultState)
    .handleAction(headerBarBannerActions.success, (state, { payload }) => {
        const remoteData = get(payload, 'data.data', [{}])[0];
        return {
            ...state,
            didInvalidate: false,
            isFetching: false,
            banner: formatData(remoteData),
        };
    })
    .handleAction(headerBarBannerActions.failure, (state, { payload }) => {
        return {
            ...state,
            isFetching: false,
            didInvalidate: true,
            error: payload.error,
        };
    })
    .handleAction(headerBarBannerActions.request, state => {
        return {
            ...state,
            isFetching: true,
            didInvalidate: false,
        };
    });

export default headerBarBannerReducer;
